module.exports = __webpack_public_path__ + "img/linerabbit.54e2dba5.png";